import script from './component-lib.esm2.js';
export { ICON_SIZES, SvgIconProps } from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', _vm._g(_vm._b({
    staticClass: "v-svg-icon",
    style: _vm.styles,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "focusable": "false",
      "aria-hidden": _vm.title ? undefined : true,
      "role": _vm.title ? 'img' : undefined,
      "viewBox": _vm.viewBox,
      "title": _vm.title
    }
  }, 'svg', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _vm.title ? _c('title', [_vm._v(_vm._s(_vm.title))]) : _vm._e()], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-44805c48_0", {
    source: ".v-svg-icon[data-v-44805c48]{user-select:none;display:inline-block;flex-shrink:0;fill:var(--icon-color);stroke:var(--icon-color);stroke-width:0;width:1em;height:1em;font-size:var(--icon-size);transform:var(--icon-rotate)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-44805c48";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var SvgIcon = __vue_component__;
export { SvgIcon as default };